// cs2310 (16/10): frase final do aceite dos formulários do imóvel ("Tenho interesse neste imóvel" e
// cadastro para liberar as fotos). Gate por codsite: os demais sites seguem com o texto de sempre.
const FINALIDADE_ACEITE_POR_CODSITE: Record<number, string> = {
    2310: 'para receber atendimento da Denis Ribeiro Negócios Imobiliários',
};

export const finalidadeAceiteForm = (site: any): string =>
    FINALIDADE_ACEITE_POR_CODSITE[Number(site?.id)] ?? 'para contatar os próximos anunciantes';
